import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import classes from './WaitlistInfo.module.scss'
import PropTypes from 'prop-types'
import WaitlistTooltip from './WaitlistTooltip'


const WaitlistInfo = ({ program }) => {
  const { t } = useTranslation()

  return (
    <>
      <div
        className={classNames('d-flex align-items-center', classes.waitlistInfo)}
        data-for={`waitlistTooltip-${program.id}`}
        data-tip
      >
        <span className={classes.waitlistCount}>
          {t('programs.waitlistDetails.waitlistInfo.onWaitlist', {
            count: program.waitlistedStudents.length,
          })}
        </span>
      </div>
      <WaitlistTooltip program={program} />
    </>
  )
}

WaitlistInfo.propTypes = {
  program: PropTypes.shape({
    id: PropTypes.number,
    waitlistedStudents: PropTypes.array,
  }),
}

export default WaitlistInfo
